<script setup lang="ts">
import { useCalculationStore } from '@/stores/calculation'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { filteredHeaders } from '@/components/calculation/utils/calculationHeaders'
import CalculationTableRow from '@/components/calculation/CalculationTableRow.vue'
import { VDataTableHeaders } from 'vuetify/components'

const store = useCalculationStore()

const { selectedItems } = storeToRefs(store)

const filteredHeadersComponent = computed<VDataTableHeaders['$props']['headers']>(() => {
  return selectedItems.value.length ? filteredHeaders(selectedItems.value[0]) : []
})
</script>

<template>
  <v-data-table
    key="id"
    :items="selectedItems"
    :headers="filteredHeadersComponent"
    color="primary"
    :items-per-page="10"
    :fixed-header="true"
    height="500px"
  >
    <template v-slot:item="{ item }">
      <CalculationTableRow :item="item" />
    </template>
  </v-data-table>
</template>

<style scoped></style>
